// ViewBannerModal.tsx

import React from "react";
import { Modal, Text, Button, Group, TextInput, Checkbox } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataSplashScreen } from "./types";

interface ViewSPModalProps {
  isOpen: boolean;
  onClose: () => void;
  spData: RowDataSplashScreen;
}

const ViewSplashScreenModal: React.FC<ViewSPModalProps> = ({
  isOpen,
  onClose,
  spData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Splash Screen
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput label="Title:" mb="sm" value={spData.title} disabled />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.bannerImageContainer}>
        {spData.img_url ? (
          <img
            src={spData.img_url}
            alt="Splash Screen Image"
            className={classes.bannerImageSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div>

      <Checkbox label="Show Splash Screen" checked={spData.isVisible} readOnly/>

      {/* <TextInput label="Route:" value={bannerData.route ? bannerData.route : ''} disabled /> */}

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewSplashScreenModal;
